module.exports = __webpack_public_path__ + "img/Amex-Website-Logo-768x682.bc34c1f4.png";